<template>
    <div>
      <el-tabs v-model="activeName" type="card" style="margin: 0 40px 0 40px;">
        <el-tab-pane label="文案" name="txtinfo">
          <el-form :inline="true" label-width="110px" style="padding: 20px 0 0 0; border-top: 1px solid #f1f1f1;">
            <el-form-item label="您想问的话:" style="margin-left: 10px;">
              <el-input style="width: 400px;" v-model="aiinfo" placeholder="请输入需要输入的AI文案信息"></el-input>
            </el-form-item>
            <el-button style="margin-left: 20px;" type="primary" icon="el-icon-search" @click="makenewwords">新话题</el-button>
            <el-button style="margin-left: 20px;" type="primary" icon="el-icon-search" @click="maketxt">生 成</el-button>
          </el-form>
          <quill-editor
            v-model="pagecontext"
            ref="myQuillEditor"
          >
          </quill-editor>
        </el-tab-pane>
        <el-tab-pane label="图片素材" name="imginfo">
          <el-form :inline="true" label-width="180px" style="padding: 20px 0 0 0; border-top: 1px solid #f1f1f1;">
            <el-form-item label="您想生成图片的文案:" style="margin-left: 10px;">
              <el-input style="width: 400px;" v-model="imginfo" placeholder="请输入需要输入的图片对应的文案"></el-input>
            </el-form-item>
            <el-button style="margin-left: 20px;" type="primary" icon="el-icon-search" @click="makeimg">生 成</el-button>
          </el-form>
          <el-form label-width="180px" style="padding: 20px 0 0 0; border-top: 1px solid #f1f1f1;">
            <el-form-item label="图片生成模式:" style="margin-left: 10px;">
              <el-radio-group v-model="mode" @input="changemode">
                <el-radio :label="2">DALL·E 2 模型</el-radio>
                <el-radio :label="3">DALL·E 3 模型</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
          <el-form label-width="180px" style="padding: 20px 0 0 0; border-top: 1px solid #f1f1f1;">
            <el-form-item label="图片尺寸:" style="margin-left: 10px;">
              <el-radio-group v-if="mode===3" v-model="imgsize" @input="changesize">
                <el-radio :label="1">1024x1792(费用：0.16$)</el-radio>
                <el-radio :label="2">1792x1024(费用：0.16$)</el-radio>
                <el-radio :label="3">1024x1024(费用：0.08$)</el-radio>
              </el-radio-group>
              <el-radio-group v-if="mode===2" v-model="imgsize" @input="changesize2">
                <el-radio :label="1">1024x1024(费用：0.04$)</el-radio>
                <el-radio :label="2">512x512(费用：0.036$)</el-radio>
                <el-radio :label="3">256x256(费用：0.032$)</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="图片自定义尺寸:" style="margin-left: 10px;">
              <el-input style="width: 160px;" disabled v-model="cus_imgsize" placeholder="请输入的图片尺寸"></el-input>
            </el-form-item>
          </el-form>
          <div style="padding: 5px 0 0px 20px;font-size: 12px;" v-if="loadshow">数据加载中,请稍等...</div>
          <div style="margin-top: 30px; display: flex; width: 100%; justify-content: center; align-items: center;">
            <img style="width:320px;height:320px;" :src="defaultimg" />
          </div>
          <div style="width: 100%; margin-top: 20px; display: flex;  align-items: center; justify-content: center;">
            <div style="width:100%;  font-size: 12px; white-space: normal; word-break: break-all; overflow: auto;">
              {{defaultimg}}
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="代码" name="codeinfo">
        </el-tab-pane>
      </el-tabs>
    </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  Vue.prototype.$http = axios
  var that
  export default {
    name: 'ChatGPT',
    data () {
      return {
        activeName: 'txtinfo',
        activeNames: ['1'],
        aiinfo: '',
        imginfo: '',
        mode: 2,
        defaultimg: 'https://img2.baidu.com/it/u=2829299963,2110257490&fm=253&fmt=auto&app=138&f=JPEG?w=256&h=256',
        loadshow: false,
        imgsize: 2,
        cus_imgsize: '1024x1024',
        questions: [],
        pagecontext: ''
      }
    },
    mounted () {
      that = this
      if (this.mode === 2) {
        if (that.imgsize === 1) {
          that.cus_imgsize = '1024x1024'
        }
        if (that.imgsize === 2) {
          that.cus_imgsize = '512x512'
        }
        if (that.imgsize === 3) {
          that.cus_imgsize = '256x256'
        }
      } else {
        if (that.imgsize === 1) {
          that.cus_imgsize = '1024x1792'
        }
        if (that.imgsize === 2) {
          that.cus_imgsize = '1792x1024'
        }
        if (that.imgsize === 3) {
          that.cus_imgsize = '1024x1024'
        }
      }
    },
    methods: {
      makenewwords () {
        this.questions = []
        that.pagecontext = ''
      },
      changemode () {
        window.console.log(this.mode)
        if (this.mode === 2) {
          if (that.imgsize === 1) {
            that.cus_imgsize = '1024x1024'
          }
          if (that.imgsize === 2) {
            that.cus_imgsize = '512x512'
          }
          if (that.imgsize === 3) {
            that.cus_imgsize = '256x256'
          }
        } else {
          if (that.imgsize === 1) {
            that.cus_imgsize = '1024x1792'
          }
          if (that.imgsize === 2) {
            that.cus_imgsize = '1792x1024'
          }
          if (that.imgsize === 3) {
            that.cus_imgsize = '1024x1024'
          }
        }
      },
      changesize () {
        if (that.imgsize === 1) {
          that.cus_imgsize = '1024x1792'
        }
        if (that.imgsize === 2) {
          that.cus_imgsize = '1792x1024'
        }
        if (that.imgsize === 3) {
          that.cus_imgsize = '1024x1024'
        }
      },
      changesize2 () {
        if (that.imgsize === 1) {
          that.cus_imgsize = '1024x1024'
        }
        if (that.imgsize === 2) {
          that.cus_imgsize = '512x512'
        }
        if (that.imgsize === 3) {
          that.cus_imgsize = '256x256'
        }
      },
      maketxt () {
        var qinfo = {
          role: 'user',
          content: that.aiinfo
        }
        that.pagecontext = that.pagecontext + '我的提问：' + that.aiinfo + '\n\n'
        this.questions.push(qinfo)
        that.$http({
          url: 'https://ai.sqnetsoft.cn/maketxtex',
          method: 'post',
          data: {
            questions: this.questions
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            if (res.data.result === 'success') {
              that.pagecontext = that.pagecontext + 'ChatGPT回答：' + res.data.data+ '\n\n'
            } else {
              that.pagecontext = that.pagecontext + '报错了，' + JSON.stringify(res.data.data)
            }
          })
          .catch(function (error) {
            window.console.log(error)
            that.pagecontext = that.pagecontext + '抱歉，报错了，请再尝试或联系管理员\n\n'
          })
      },
      makeimg () {
        that.loadshow = true
        that.$http({
          url: 'https://ai.sqnetsoft.cn/makegptimgex',
          method: 'post',
          data: {
            saywords: that.imginfo,
            size: that.cus_imgsize,
            mode: that.mode.toString()
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            that.loadshow = false
            if (res.data.result === 'success') {
              that.defaultimg = res.data.data
            }
            window.open(that.defaultimg)
          })
          .catch(function (error) {
            window.console.log(error)
          })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/chatgpt/ChatGPT.vue